import BigNumber from 'bignumber.js';

export const formatAmountByDecimal = (options: {
  value: string | number;
  decimals?: number;
  separator?: string;
  keepZero?: boolean;
  trailingZeros?: boolean;
  prefix?: string;
  suffix?: string;
  isCast?: boolean;
}) => {
  const { value, decimals = 8, separator = ',', keepZero = false, trailingZeros = true, isCast = true } = options;

  const isNegativie = new BigNumber(value).isNegative();

  const invalidinput = !validateInput(value);

  const absValue = new BigNumber(value).abs().toString();

  if (invalidinput) return '';
  const hasDot = `${absValue}`.includes('.');
  const [integerPart, decimalPart] = `${absValue}`.split('.');

  const convertIntegerPart = keepZero ? integerPart : new BigNumber(integerPart).toString();
  const formattedIntegerPart = integerThousandSeparator(convertIntegerPart, separator);

  const convertDecimalPart = decimalPart;
  let parsedDecimalPart = decimalPart && convertDecimalPart.replace('.', '');

  let result = '';
  if (!parsedDecimalPart && !trailingZeros) {
    result = `${formattedIntegerPart}${hasDot ? '.' : ''}`;
  } else {
    // remove any dots from decimalPart
    // let formattedDecimalPart = parsedDecimalPart ? `${parsedDecimalPart.slice(0, decimals)}` : `${'0'.repeat(decimals)}`;
    let formattedDecimalPart = parsedDecimalPart ? `${parsedDecimalPart.slice(0, decimals)}` : undefined;
    if (isCast) {
      if (formattedDecimalPart) {
        if (formattedDecimalPart.length < decimals) {
          formattedDecimalPart += Array(decimals - formattedDecimalPart.length + 1).join('0');
        }
      } else {
        formattedDecimalPart = Array(decimals + 1).join('0');
      }
    }
    result = formattedDecimalPart ? `${formattedIntegerPart}.${formattedDecimalPart}` : `${formattedIntegerPart}`;
  }

  if (isNegativie) {
    result = `-${result}`;
  }

  if (options.prefix) {
    result = `${options.prefix} ${result}`;
  }

  if (options.suffix) {
    result = `${result} ${options.suffix}`;
  }

  return result;
};

const validateInput = (value: string | number) => {
  return !new BigNumber(value).isNaN();
};

const integerThousandSeparator = (value: string, separator: string) => {
  return value
    .split('')
    .reverse()
    .reduce((acc, curr, index) => {
      if (index % 3 === 0 && index !== 0) {
        return `${curr}${separator}${acc}`;
      }
      return `${curr}${acc}`;
    }, '');
};
